'use strict';

export const storeSearchView = Backbone.View.extend({

  initialize: function () {
    this.userSelection = cookieManagement.getCookie('storedSearchParams') !== null ? JSON.parse(cookieManagement.getCookie('storedSearchParams')) : {};
    SEARCH_SCRIPTS.CURRENT_SEARCH_PARAMETERS = this.userSelection;

    this.listenTo(dispatcher, 'search:updateMainSearchStore', this.updateMainSearchStore);
    this.listenTo(dispatcher, 'search:memorizingMainSearchCriteria', this.memorizingMainSearchCriteria);
  },

  memorizingMainSearchCriteria: function (callback = false) {
    if (Object.keys(this.userSelection).length === 0) {
      cookieManagement.eraseCookie('storedSearchParams');
    } else {
      if (this.attributes.mainSearch.getResume().accommodationNb === 1 && typeof this.userSelection.multiparticipants !== 'undefined' && this.userSelection.multiparticipants.length > 1) {
        this.userSelection.multiparticipants = this.userSelection.multiparticipants.slice(0, 1);
      }

      cookieManagement.createCookie('storedSearchParams', JSON.stringify(this.userSelection), 30);
    }

    if (DEVICE.isMobile) {
      dispatcher.trigger('search:updateLastSearches');
    }

    if (callback && typeof callback === 'function') {
      callback();
    }
  },

  updateMainSearchStore: function (facetteName, value, validate = false) {
    if (value !== null) {
      this.userSelection[facetteName] = value;
    } else {
      //deleting objet item
      delete this.userSelection[facetteName];
    }

    //update stored values in search_scripts to compare current search parameters to memorized search params
    SEARCH_SCRIPTS.CURRENT_SEARCH_PARAMETERS = this.userSelection;

    if (validate) {
      this.memorizingMainSearchCriteria();
    }
  }
});